"use client"

import { Stack, Button, Divider } from "@mantine/core"
import { FcGoogle } from "react-icons/fc"
import { FaMicrosoft } from "react-icons/fa6"

export interface SocialLoginButtonsTranslations {
  orContinueWith: string
  signInWithGoogle: string
  signInWithMicrosoft: string
}

export interface SocialLoginButtonsProps {
  oauthAction: (formData: FormData) => void | Promise<void>
  translations: SocialLoginButtonsTranslations
}

const defaultTranslations: SocialLoginButtonsTranslations = {
  orContinueWith: "Or continue with",
  signInWithGoogle: "Continue with Google",
  signInWithMicrosoft: "Continue with Microsoft",
}

export function SocialLoginButtons({
  oauthAction,
  translations,
}: SocialLoginButtonsProps) {
  const t = { ...defaultTranslations, ...translations }

  return (
    <>
      <Divider my="lg" label={t.orContinueWith} labelPosition="center" />

      <Stack gap="sm">
        <form action={oauthAction}>
          <input type="hidden" name="provider" value="google" />
          <Button type="submit" variant="default" fullWidth leftSection={<FcGoogle size={18} />}>
            {t.signInWithGoogle}
          </Button>
        </form>

        <form action={oauthAction}>
          <input type="hidden" name="provider" value="azure" />
          <Button type="submit" variant="default" fullWidth leftSection={<FaMicrosoft size={16} color="#00a4ef" />}>
            {t.signInWithMicrosoft}
          </Button>
        </form>
      </Stack>
    </>
  )
}
